import { TrackInfo } from '../../model/track-info';

export const trackDefaultIncomeBasic = [
    new TrackInfo('income-wealthincome', ['income', 'income-wealthincome']),
    new TrackInfo('income-patrimony', ['income', 'patrimony']),
];
